import { useEffect, useRef } from 'react';

export const useResizeEffect = (callback: () => void, timeout: number = 200): void => {
  const resizeTimeoutRef = useRef<number | null>(null);
  const resizeHandlerQueuedRef = useRef<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      if (!resizeHandlerQueuedRef.current) {
        resizeHandlerQueuedRef.current = true;
        setTimeout(() => {
          resizeHandlerQueuedRef.current = false;
          callback();
        }, timeout);
      }
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      resizeTimeoutRef.current = setTimeout(() => {
        callback();
      }, timeout) as unknown as number;
    };

    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [callback, timeout]);
};
